export enum TypeEntryEnum {
  SolicitationEntry,
  TransferEstablishment,
  ExternalEntry = 5
}
